import React from 'react';
import type { LabelCanvasWrapGuide } from './productLabelTypes';

type GridOverlayProps = {
  labelW: number;
  labelH: number;
  gridPct: number;
  visible: boolean;
};

export function LabelCanvasGridOverlay({ labelW, labelH, gridPct, visible }: GridOverlayProps) {
  if (!visible || gridPct <= 0) return null;
  const stepX = (gridPct / 100) * labelW;
  const stepY = (gridPct / 100) * labelH;
  return (
    <div
      data-label-editor-chrome
      className="pointer-events-none absolute inset-0 z-[9990]"
      style={{
        backgroundImage: `
          linear-gradient(to right, rgba(14,165,233,0.12) 1px, transparent 1px),
          linear-gradient(to bottom, rgba(14,165,233,0.12) 1px, transparent 1px)
        `,
        backgroundSize: `${stepX}px ${stepY}px`,
      }}
    />
  );
}

type WrapGuideProps = {
  mode: LabelCanvasWrapGuide;
  labelW: number;
};

export function LabelWrapGuideOverlay({ mode, labelW }: WrapGuideProps) {
  if (mode === 'none') return null;

  const panels =
    mode === '3-panel'
      ? [
          { x: 33.333, label: 'Left panel' },
          { x: 66.666, label: 'Front · Right' },
        ]
      : [{ x: 50, label: 'Back · Front' }];

  return (
    <div data-label-editor-chrome className="pointer-events-none absolute inset-0 z-[9991]">
      {panels.map((p) => (
        <div
          key={p.x}
          className="absolute top-0 h-full border-l-2 border-dashed border-violet-500/70"
          style={{ left: `${p.x}%` }}
        >
          <span
            className="absolute left-1 top-1 rounded bg-violet-600/90 px-1 py-0.5 text-[8px] font-bold uppercase tracking-wide text-white"
            style={{ writingMode: p.x > 50 ? 'vertical-rl' : undefined }}
          >
            {p.label}
          </span>
        </div>
      ))}
      {mode === '3-panel' ? (
        <>
          <span
            className="absolute left-[17%] top-1 rounded bg-violet-600/80 px-1 py-0.5 text-[8px] font-semibold text-white"
          >
            Side
          </span>
          <span
            className="absolute left-[50%] top-1 -translate-x-1/2 rounded bg-violet-600/80 px-1 py-0.5 text-[8px] font-semibold text-white"
          >
            Front (center)
          </span>
          <span
            className="absolute right-[17%] top-1 rounded bg-violet-600/80 px-1 py-0.5 text-[8px] font-semibold text-white"
          >
            Side
          </span>
        </>
      ) : null}
      <div
        className="absolute bottom-1 left-1/2 -translate-x-1/2 rounded bg-violet-700/90 px-2 py-0.5 text-[8px] text-white"
        style={{ maxWidth: labelW * 0.9 }}
      >
        {mode === '3-panel'
          ? 'Wrap guide: design left panel · front center · right panel (not printed)'
          : 'Wrap guide: back half · front half (not printed)'}
      </div>
    </div>
  );
}
